import React from 'react';
import { PILLARS } from '../constants';

const Pillars: React.FC = () => {
  return (
    <section className="h-full w-full bg-white text-black flex items-center px-6 lg:px-20 overflow-y-auto py-12 md:py-20">
      <div className="max-w-[1440px] mx-auto w-full">
        <div className="mb-12">
           <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-2 italic">The Studio</h2>
           <p className="text-black/40 font-bold uppercase tracking-widest text-xs">Our three fundamental pillars of creation.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-px bg-black/10 border border-black/10 w-full mb-12">
          {PILLARS.map((pillar, idx) => (
            <div key={idx} className="bg-white p-8 lg:p-16 flex flex-col justify-center">
              <div className="text-primary mb-6">
                <span className="material-symbols-outlined text-5xl">{pillar.icon}</span>
              </div>
              <h3 className="text-3xl font-black uppercase tracking-tighter mb-4 italic">{pillar.title}</h3>
              <p className="text-black/60 text-base leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center py-10 border-t-2 border-primary/10 gap-8">
          <div className="flex items-center gap-4">
            <span className="size-3 bg-primary rounded-full animate-ping"></span>
            <span className="text-xs font-black uppercase tracking-[0.4em] text-black">Studio Help Desk Active</span>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-16 bg-zinc-50 p-6 md:p-10 border border-black/5 w-full md:w-auto">
            <div className="flex flex-col items-center md:items-end">
              <span className="text-[10px] font-black uppercase tracking-[0.3em] text-primary mb-3">Questions? Contact Rob Directly</span>
              <a 
                href="mailto:rob@theapps.io" 
                className="text-3xl md:text-4xl font-black uppercase tracking-tighter hover:text-primary transition-all italic border-b-4 border-primary/30 hover:border-primary"
              >
                rob@theapps.io
              </a>
            </div>
            <a 
              href="mailto:rob@theapps.io"
              className="bg-black text-white px-8 py-4 font-black uppercase tracking-widest text-xs hover:bg-primary transition-colors"
            >
              Email Support
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pillars;